import { cn } from '@/lib/utils';
import { ReactNode } from 'react';

interface PrimaryButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  disabled?: boolean;
  /** When set, forwarded as the native `type` attribute (use `button` outside forms). */
  nativeType?: 'button' | 'submit' | 'reset';
}

export const PrimaryButton = ({
  children,
  onClick,
  className,
  variant = 'primary',
  size = 'md',
  disabled = false,
  nativeType,
}: PrimaryButtonProps) => {
  const baseClasses = "font-medium rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2";
  
  const variantClasses = {
    primary: "bg-bodhi-teal text-white hover:bg-bodhi-teal/90 focus:ring-bodhi-teal shadow-md",
    secondary: "bg-gray-100 text-bodhi-text-dark hover:bg-gray-200 focus:ring-gray-300",
    outline: "border-2 border-bodhi-teal text-bodhi-teal hover:bg-bodhi-teal hover:text-white focus:ring-bodhi-teal shadow-sm"
  };
  
  const sizeClasses = {
    sm: "px-3 py-2 text-sm",
    md: "px-4 py-2.5 text-sm",
    lg: "px-6 py-3 text-base"
  };

  return (
    <button
      type={nativeType}
      onClick={onClick}
      disabled={disabled}
      className={cn(
        baseClasses,
        variantClasses[variant],
        sizeClasses[size],
        className,
        disabled && "opacity-50 cursor-not-allowed"
      )}
    >
      {children}
    </button>
  );
};
